"use client";

import { ExpandableElement } from "@/components/ExpandableElement";
import {
  Blocks,
  BuilderBlock,
  BuilderContextInterface,
  isEditing,
  isPreviewing,
  RegisteredComponents,
} from "@builder.io/sdk-react";
import { FC } from "react";

export type ExpandableElementBlockProps = {
  isOpen?: boolean;
  transitionDuration?: string;
  onToggle?: (isOpen: boolean) => void;
  buttonElement: BuilderBlock[];
  content: BuilderBlock[];
  builderBlock: BuilderBlock;
  builderComponents: RegisteredComponents;
  builderLinkComponent: unknown;
  builderContext: BuilderContextInterface;
};

export const ExpandableElementBlock: FC<ExpandableElementBlockProps> = ({
  isOpen,
  transitionDuration,
  onToggle,
  buttonElement,
  content,
  builderBlock,
  builderComponents,
  builderLinkComponent,
  builderContext,
}) => {
  const builderId = builderBlock?.id;

  const ButtonBlock = (
    <Blocks
      blocks={buttonElement}
      parent={builderId}
      registeredComponents={builderComponents}
      linkComponent={builderLinkComponent}
      context={builderContext}
      path="buttonElement"
    />
  );

  const ContentBlock = (
    <Blocks
      blocks={content}
      parent={builderId}
      registeredComponents={builderComponents}
      linkComponent={builderLinkComponent}
      context={builderContext}
      path="content"
    />
  );

  return isEditing() || isPreviewing() ? (
    <div className="flex w-fit flex-col gap-4">
      <div className="flex flex-col gap-2">
        <span className="border-b border-black font-bold">Button Element:</span>
        <span>{ButtonBlock}</span>
      </div>
      <div className="flex flex-col gap-2">
        <span className="border-b border-black font-bold">Content:</span>
        <span>{ContentBlock}</span>
      </div>
    </div>
  ) : (
    <ExpandableElement
      buttonElement={ButtonBlock}
      contentElement={ContentBlock}
      isOpen={isOpen}
      transitionDuration={transitionDuration}
      onToggle={onToggle}
    />
  );
};
